import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useGetAvailableLanguages } from "../../hooks/global/Languages";

function GroupProductsTextInput({ index, value = "", complex = true, onChange, error = false, validate=false
 }) {
    const { t, i18n } = useTranslation();
    const availableLan = useGetAvailableLanguages();
    const [inputValue, setInputValue] = useState(value || "");


    useEffect(() => {
        setInputValue(value);
    }, [value])

    const handleInputChange = (event) => {
        let temp;
        if (complex) {
            temp = { ...inputValue }
            temp[event.target.name] = event.target.value
        } else {
            temp = event.target.value;
        }
        setInputValue(temp);

        if (typeof onChange === 'function') {
            onChange({
                type: 'onChange',
                data: temp,
                index: index,
            });
        }
    };

    return (
        <div className="inputWrapCustom">
            {complex ? (

                availableLan.map((lng, key) => {
                    return (
                        <div key={key}>
                            <label>{lng}: </label>
                            <input type="text"
                                key={lng}
                                value={inputValue[lng] || ""}
                                name={lng}
                                onChange={handleInputChange}
                                placeholder="Enter a value"
                                autoFocus={true} />
                            {error && !validate[`${index}.${lng}`] && (<span className="validation">{t("err.req")}</span>)}
                        </div>
                    )
                })
            ) : (
                <div>
                    <input type="text"
                value={inputValue || ""}
                name={index}
                onChange={handleInputChange}
                placeholder="Enter a value"
                autoFocus={true} />
                    {error && !validate[`${index}`] && (<span className="validation">{t("err.req")}</span>)}
                </div>
                )}
        </div>
    );
}

export default GroupProductsTextInput;
